<template>
  <v-select
    v-model="selected"
    :items="list"
    :label="label"
    ref="singleSelect"
    hide-details
  ></v-select>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: false
    },
    item: {
      type: String,
      required: false
    },
    list: {
      type: Array,
      required: false
    }
  },
  computed: {
    selected: {
      get() {
        return this.item;
      },
      set(value) {
        this.$refs.singleSelect.blur();
        this.$emit("selected", value);
      }
    }
  }
};
</script>
